var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49935 3.61198H2.83268C2.39065 3.61198 1.96673 3.78757 1.65417 4.10013C1.34161 4.4127 1.16602 4.83662 1.16602 5.27865V15.2786C1.16602 15.7207 1.34161 16.1446 1.65417 16.4572C1.96673 16.7697 2.39065 16.9453 2.83268 16.9453H11.166C11.608 16.9453 12.032 16.7697 12.3445 16.4572C12.6571 16.1446 12.8327 15.7207 12.8327 15.2786V5.27865C12.8327 4.83662 12.6571 4.4127 12.3445 4.10013C12.032 3.78757 11.608 3.61198 11.166 3.61198H9.49935M4.49935 3.61198C4.49935 4.05401 4.67494 4.47793 4.98751 4.79049C5.30007 5.10305 5.72399 5.27865 6.16602 5.27865H7.83268C8.27471 5.27865 8.69863 5.10305 9.01119 4.79049C9.32375 4.47793 9.49935 4.05401 9.49935 3.61198M4.49935 3.61198C4.49935 3.16995 4.67494 2.74603 4.98751 2.43347C5.30007 2.12091 5.72399 1.94531 6.16602 1.94531H7.83268C8.27471 1.94531 8.69863 2.12091 9.01119 2.43347C9.32375 2.74603 9.49935 3.16995 9.49935 3.61198M6.99935 9.44531H9.49935M6.99935 12.7786H9.49935M4.49935 9.44531H4.50768M4.49935 12.7786H4.50768",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.9650f9ef3872f14cdd918a81cd9db546.svg";
export { ForwardRef as ReactComponent };